<template>
  <modal :modal-key="'how_to_get_prize_modal'" @close="$emit('close')" class="modal--welcomeback modal--zero-balance" :body-style="'prize_info'">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_achievements_how_to_get_prize_title }}</h1>
      <img class="add_shortcut" src="static/images/bonus_points.svg" alt="">
    </template>
    <template slot="body">
     {{ getTranslations.home_modals_achievements_how_to_get_prize_description }}
    </template>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';

export default {
  name: 'how-to-get-prize',
  components: {
    Modal,
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/achievements/HowToGetPrize.vue